import lang from '../../lib/language';

export const EPIC_MOVERS_SYMBOL_NAME_LIMIT = 20;
export const EPIC_MOVERS_ROW_COUNT = 4;
export const EPIC_MOVERS_TOP_ROW_COUNT = 8;
export const EPIC_MOVERS_TABLE_HEADERS = [
  lang.commonEpicMoversSymbolName(),
  lang.commonEpicMoversLastPriceChanges(),
];
